import { Percent } from "@mui/icons-material";
import {
    Box,
    Button,
    CardContent,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControlLabel,
    FormGroup,
    Grid,
    Tooltip,
    Typography,
    useTheme,
} from "@mui/material";
import { Stack } from "@mui/system";
import {
    IconCurrencyRupee,
    IconEye,
    IconPencil,
    IconTrash,
} from "@tabler/icons";
import { useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // import first
import { axiosInstance } from "src/api/axios";
import BlankCard from "../../components/shared/BlankCard";

const AdminProductGrid = () => {
  const [product, setProduct] = useState([]);
  const { category } = useParams();
  const theme = useTheme();
  const [productImages, setProductImages] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [deletableProduct, setDeletableProduct] = useState(null);

  useMemo(() => {
    axiosInstance.get("/users").then((res) => {
      if (res.status < 210) {
        let _ = res.data;
        if (!_?.role.includes("admin")) {
          window.location.href = "/";
        }
      }
    });
  }, []);
  useEffect(() => {
    axiosInstance.get("/product?all=").then((response) => {
      console.log(response.data);
      if (response.data && response.data.length) {
        setProduct(response.data);
        let images = response.data.map((data, index) => {
          if (data.images.length) {
            return data.images[0];
          }
        });
        setProductImages(images);
        console.log(images);
      }
    });
  }, [category]);

  const setTop = (id, flag) => {
    axiosInstance
      .patch(`/product/${id}?top=`, { top: flag })
      .then((res) => {
        console.log(res.data);
        if (res.status < 210) {
          let temp = product;
          let row = temp.findIndex((j) => j.id === id);
          temp[row].top = flag;
          setProduct([...temp]);
          // alert('Product Edited successfully');
          // window.location.href = '/admin/';
        } else {
          alert("something went wrong");
        }
      })
      .catch((error) => {
        if (error) {
          console.log(error.status, error.message, error.response, error.data);
          console.log(Object.keys(error));
        }
      });
  };

  const deleteProduct = () => {
    axiosInstance
      .delete(`/product/${deletableProduct}`)
      .then((res) => {
        console.log(res.status);
        if (res?.status < 210) {
          console.log(product);
          setProduct((product) =>
            product.filter((i) => i.id !== deletableProduct)
          );
          setModalOpen(false);
        }
      })
      .catch((e) => {
        console.log(e);

        return toast.error("Something went wrong ");
      })
      .finally(() => {
        setDeletableProduct(null);
      });
  };
  return (
    <Grid container spacing={3}>
      {product.map((product, index) =>
        product.images.length ? (
          <Grid item xs={12} sm={6} key={index}>
            <BlankCard>
              <CardContent sx={{ p: 2 }}>
                <Grid container xs={12} spacing={1}>
                  <Grid item xs={12}>
                    <Stack direction={"row"} justifyContent={"flex-end"}>
                      <Box
                        sx={{
                          p: 1.2,
                          borderRadius: 2,
                          opacity: 0.7,
                          color: "white",
                          fontWeight: 700,
                          bgcolor: theme.palette.earnpati.success,
                        }}
                      >
                        {product.status}
                      </Box>
                    </Stack>
                  </Grid>
                  <Grid item xs={5}>
                    <Tooltip title={`Grab Offer for ${product.title}`}>
                      <img
                        src={productImages[index]}
                        alt="img"
                        width="90%"
                        style={{ minHeight: "100%" }}
                      />
                    </Tooltip>
                  </Grid>
                  <Grid container xs={7} sx={{ pt: 2 }} spacing={0.5}>
                    <Grid item>
                      <Typography variant="h5">{product.title}</Typography>
                      <Typography>ID:{product._id || product?.id}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography
                        sx={{
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          width: "105%",
                          overflow: "hidden",
                        }}
                      >
                        {product.info}
                      </Typography>
                    </Grid>
                    <Grid item width={"100%"}>
                      <Stack direction={"row"} justifyContent={"space-between"}>
                        <Typography
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            fontWeight: 700,
                            fontSize: "16px",
                          }}
                        >
                          {product.earntype || "Earn Upto"}:{" "}
                          {!product?.isPercentage ? (
                            <>
                              <IconCurrencyRupee style={{ width: "24px" }} />
                              <p>{product.earnUpto}</p>
                            </>
                          ) : (
                            <>
                              {" "}
                              <p>{product.earnUpto}</p>
                              <Percent style={{ width: "24px" }} />
                            </>
                          )}
                        </Typography>
                        <FormGroup sx={{ alignSelf: "center" }}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={product?.top}
                                value="something"
                                onClick={(e) => {
                                  console.log(e.target);
                                  if (e.target.checked) {
                                    // e.target.checked = true;
                                    setTop(product.id, true);
                                  } else {
                                    // e.target.checked = false;
                                    setTop(product.id, false);
                                  }
                                }}
                              />
                            }
                            label="Top"
                          />
                        </FormGroup>
                      </Stack>
                    </Grid>

                    <Grid item xs={8}>
                      <Stack direction={"row"} spacing={3}>
                        <Typography
                          component={Link}
                          to={`/admin/edit-products/${product.id}`}
                          style={{
                            position: "relative",
                            textDecoration: "none",
                          }}
                        >
                          <Button
                            sx={{
                              bgcolor: theme.palette.earnpati.main,
                              color: "white",
                              "&:hover": {
                                backgroundColor: theme.palette.earnpati.success,
                                cursor: "pointer",
                              },
                            }}
                            variant="text"
                            size="medium"
                          >
                            Edit <IconPencil />
                          </Button>
                        </Typography>
                        <Typography
                          component={Link}
                          to={`/products/${product.id}`}
                          style={{
                            position: "relative",
                            textDecoration: "none",
                          }}
                        >
                          <Button
                            sx={{
                              bgcolor: theme.palette.earnpati.main,
                              color: "white",
                              "&:hover": {
                                backgroundColor: theme.palette.earnpati.success,
                                cursor: "pointer",
                              },
                            }}
                            variant="text"
                            size="medium"
                          >
                            View <IconEye />
                          </Button>
                        </Typography>
                        <Button
                          sx={{
                            bgcolor: theme.palette.earnpati.main,
                            color: "white",
                            "&:hover": {
                              backgroundColor: theme.palette.earnpati.success,
                              cursor: "pointer",
                            },
                          }}
                          variant="text"
                          size="medium"
                          onClick={() => {
                            setModalOpen(true);
                            setDeletableProduct(product.id);
                          }}
                        >
                          Delete <IconTrash />
                        </Button>
                        <Dialog open={modalOpen}>
                          <DialogTitle>Delete Confirmation</DialogTitle>
                          <DialogContent>
                            <DialogContentText>
                              Are you sure you want to delete this?
                            </DialogContentText>
                          </DialogContent>
                          <DialogActions>
                            <Button onClick={() => setModalOpen(false)}>
                              Cancel
                            </Button>
                            <Button onClick={() => deleteProduct()}>
                              Confirm
                            </Button>
                          </DialogActions>
                        </Dialog>
                      </Stack>
                    </Grid>
                  </Grid>
                </Grid>
              </CardContent>
            </BlankCard>
          </Grid>
        ) : null
      )}
      <ToastContainer />
    </Grid>
  );
};

export default AdminProductGrid;
